export default __webpack_public_path__ + "static/media/CMS_Settings.828edfae.svg";